import Vue from 'vue'

const state = {
    // 
}

const getters = {
    // 
}

const actions = {
    settingRequest: async ({commit}, queries) => {
        let url = `/api/settings/${queries.key}`;

        return new Promise((resolve, reject) => {
            Vue.axios.get(url)
                .then(result => {
                    resolve(result.data)
                })
                .catch(err => {
                    if (err.response.status == 403)
                        commit('setSnack', {'type': 'red', 'msg': 'Action non autorisée'})
                    reject(err)
                })
        })
    },
}

const mutations = {
    // 
}

export default {
    state,
    getters,
    actions,
    mutations,
}